import { render } from "./updatePrix.vue?vue&type=template&id=67f6e5d2&scoped=true"
import script from "./updatePrix.vue?vue&type=script&lang=js"
export * from "./updatePrix.vue?vue&type=script&lang=js"

import "./updatePrix.vue?vue&type=style&index=0&id=67f6e5d2&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f6e5d2"]])

export default __exports__